import ButtonGroup from "./ButtonGroup.vue";
import ButtonGroupButton from "./ButtonGroupButton.vue";
import { pluginify } from "./../../util";
export default pluginify(ButtonGroup, ButtonGroupButton);
export { ButtonGroup, ButtonGroupButton };
